import {
  IEditLocation,
  ILocation,
  IProvince,
  IResponseGetLocationByPersons,
  IResponseGetLocation,
  IWard,
  IParamsGetLocation,
} from '~/utils/interface/location';
import axiosClient from './axiosClient';

const url: string = '/api/locations';

const locationApi = {
  getListProvinces() {
    return axiosClient.get<IProvince[]>(url + '/provinces');
  },

  getByPersons(id: string) {
    return axiosClient.get<IResponseGetLocationByPersons>(url + '/by-person/' + id);
  },

  getListWards(params: { province: string }) {
    return axiosClient.get<IWard[]>(url + '/wards', { params });
  },

  getList(params: IParamsGetLocation) {
    return axiosClient.get<IResponseGetLocation>(url, { params });
  },

  create(data: IEditLocation) {
    return axiosClient.post<ILocation>(url, data);
  },

  update(id: string, data: IEditLocation) {
    return axiosClient.put<IEditLocation>(`${url}/${id}`, data);
  },

  delete(id: string) {
    return axiosClient.delete<IEditLocation>(`${url}/${id}`);
  },
};

export default locationApi;
